<template>
  <div v-if="$ability.can('write', 'Sale')">
    <div class="card">
      <Steps :model="items" :readonly="false" />
    </div>
    <router-view
      v-slot="{ Component }"
      @prevPage="prevPage($event)"
      @nextPage="nextPage($event)"
      @changePage="changePage($event)"
    >
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import { mapActions } from 'vuex';
import Steps from 'primevue/steps';

export default {
  components: {
    Steps,
  },
  data() {
    return {
      items: [
        {
          label: 'Comprador',
          to: '/vendas/cadastro',
        },
        {
          label: 'Bovinos',
          to: '/vendas/cadastro/bovinos',
        },
        {
          label: 'Valores',
          to: '/vendas/cadastro/valores',
        },
        {
          label: 'Revisão',
          to: '/vendas/cadastro/revisao',
        },
      ],
    };
  },
  async created() {
    if (this.$route.params.bovineImport) {
      const importBovines = JSON.parse(this.$route.params.bovineImport);
      await this.addBovines(importBovines);
    } else {
      this.clearForm();
    }
  },
  methods: {
    ...mapActions('sale', ['clearForm', 'addBovines']),
    nextPage(event) {
      this.$router.push(this.items[event.pageIndex + 1].to);
    },
    prevPage(event) {
      this.$router.push(this.items[event.pageIndex - 1].to);
    },
    changePage(event) {
      this.$router.push(this.items[event.index].to);
    },
  },
};
</script>

<style scoped>
div >>> ul > li.p-highlight > a > span.p-steps-number {
  background: #2196f3 !important;
  color: #fff !important;
}

@media (min-width: 600px) {
  div >>> .p-steps-item .p-menuitem-link {
    flex-direction: row;
  }

  div >>> .p-steps-title,
  div >>> .p-steps .p-steps-item:before {
    margin-top: 0 !important;
  }

  div >>> .p-steps-item {
    justify-content: left;
    margin-right: 10px;
  }

  div >>> ul > li.p-steps-item > a > span.p-steps-number {
    min-width: 2.3rem !important;
    height: 2.3rem !important;
    border: none !important;
  }

  div >>> .p-steps-title {
    z-index: 1;
    background: #fff;
    padding: 0 20px 0 10px;
  }
}
</style>
